import { render } from "./banquet-hall.vue?vue&type=template&id=6fa12696"
import script from "./banquet-hall.vue?vue&type=script&lang=js"
export * from "./banquet-hall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__